import { HTTP } from './requests'

function makeDollar(root) {
  function wrap(nodes) {
    nodes = Array.from(nodes || []);
    const api = {
      nodes,
      empty() { nodes.forEach(n => { n.innerHTML = ''; }); return api; },
      append(html) { nodes.forEach(n => { if (typeof html === 'string') n.insertAdjacentHTML('beforeend', html); else n.appendChild(html); }); return api; },
      val(value) {
        if (value === undefined) {
          if (!nodes[0]) return undefined;
          if (nodes[0].tagName === 'SELECT' && nodes[0].multiple) {
            return Array.from(nodes[0].options).filter(o => o.selected).map(o => o.value);
          }
          return nodes[0].value;
        }
        nodes.forEach(n => { n.value = value; });
        return api;
      },
      prop(name, value) { if (value === undefined) return nodes[0] ? nodes[0][name] : undefined; nodes.forEach(n => { n[name] = value; }); return api; },
      text(value) { if (value === undefined) return nodes[0] ? nodes[0].textContent : undefined; nodes.forEach(n => { n.textContent = value; }); return api; },
      html(value) { if (value === undefined) return nodes[0] ? nodes[0].innerHTML : undefined; nodes.forEach(n => { n.innerHTML = value; }); return api; },
      toggle(show) { nodes.forEach(n => { n.style.display = show ? '' : 'none'; }); return api; },
      show() { nodes.forEach(n => { n.style.display = 'block'; }); return api; },
      hide() { nodes.forEach(n => { n.style.display = 'none'; }); return api; },
      on(event, handler) { nodes.forEach(n => n.addEventListener(event, function(e){ if (!e.originalEvent) e.originalEvent = e; handler.call(n, e); })); return api; },
      off() { return api; },
      each(handler) { nodes.forEach((n,i) => handler.call(n, i, n)); return api; },
      attr(name, value) { if (value === undefined) return nodes[0] ? nodes[0].getAttribute(name) : undefined; nodes.forEach(n => n.setAttribute(name, value)); return api; },
      find(selector) {
        if (!nodes[0]) return wrap([]);
        if (selector === 'option:selected') return wrap(Array.from(nodes[0].querySelectorAll('option')).filter(o => o.selected));
        return wrap(nodes[0].querySelectorAll(selector));
      },
      addClass(cls) { nodes.forEach(n => n.classList.add(cls)); return api; },
      removeClass(cls) { nodes.forEach(n => n.classList.remove(cls)); return api; },
      children() { return wrap(nodes[0] ? nodes[0].children : []); },
      data(name) {
        if (!nodes[0]) return undefined;
        const key = String(name || '').replace(/[A-Z]/g, c => '-' + c.toLowerCase());
        return nodes[0].getAttribute('data-' + key);
      }
    };
    return api;
  }
  function $(selector) {
    if (typeof selector === 'function') { selector(); return; }
    if (selector && selector.nodeType) return wrap([selector]);
    return wrap(root.querySelectorAll(selector));
  }
  $.ajax = function(options) {
    const method = (options.type || 'GET').toLowerCase();
    const config = {};
    if (options.contentType) config.headers = { 'Content-Type': options.contentType };
    if (options.xhrFields && options.xhrFields.responseType === 'blob') config.responseType = 'blob';
    let payload = options.data;
    if (typeof payload === 'string') {
      try { payload = JSON.parse(payload); } catch (e) { payload = options.data; }
    }
    if (method === 'delete' && payload !== undefined) config.data = payload;
    let promise;
    if (method === 'get') promise = HTTP.get(options.url, config);
    else if (method === 'post') promise = HTTP.post(options.url, payload, config);
    else if (method === 'put') promise = HTTP.put(options.url, payload, config);
    else if (method === 'delete') promise = HTTP.delete(options.url, config);
    else promise = HTTP.get(options.url, config);
    promise.then(response => {
      if (options.success) options.success(response.data);
    }).catch(error => {
      const err = { responseText: error?.response?.data?.error || error.message };
      if (error?.response?.data) err.responseJSON = error.response.data;
      if (options.error) options.error(err);
    });
  };
  return $;
}

export function installAdHocReporting(root, apiBase, orgId) {
  const API_BASE = apiBase;
  const ORG_ID = orgId;
  const $ = makeDollar(root);

  function safeApiErrorMessage(xhr, fallback) {
    const payload = xhr && xhr.responseJSON;
    const message = payload && typeof payload.error === 'string' ? payload.error : '';
    const verboseBackendPattern = /(psycopg2|sqlalchemy|traceback|\[sql:|\[parameters:|background on this error|relation "|invalidtextrepresentation|undefinedtable)/i;
    let safeMessage = message && !verboseBackendPattern.test(message) ? message : fallback;
    if (payload && payload.error_id) safeMessage += ` Reference: ${payload.error_id}`;
    return safeMessage;
  }

        let selectedTables = []; // table instance aliases, e.g. users, users-1, users-2
        let tableAliases = {};   // alias -> real table name
        let selectedColumns = {};
        let joinConditions = [];
        let filterConditions = [];
        let tableColumns = {};
        let selectedColumnOrder = [];
        let currentFilterTable = null;
        let currentJoinIndex = null;
        let currentJsonbItem = null;
        let currentAliasIndex = null;
        let previewTimer = null;
        let selectedColumnUid = 1;
        let currentSavedReportId = null;
        let currentSavedReportUserCreated = true;
        let currentSavedReportName = '';
        let currentOrganizationId = null;
        let availableTablesRequestSeq = 0;

        function safeId(value) {
            return String(value).replace(/[^a-zA-Z0-9_-]/g, '_');
        }

        function escapeHtml(value) {
            return String(value ?? '').replace(/[&<>'"]/g, char => ({
                '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
            }[char]));
        }

        function jsString(value) {
            return String(value ?? '').replace(/\\/g, '\\\\').replace(/'/g, "\\'");
        }

        const PLAIN_LABEL_RE = /^[A-Za-z0-9][A-Za-z0-9 _().-]{0,127}$/;
        const JOIN_CONDITION_RE = /^[A-Za-z_][A-Za-z0-9_-]*\.[A-Za-z_][A-Za-z0-9_]*\s*=\s*[A-Za-z_][A-Za-z0-9_-]*\.[A-Za-z_][A-Za-z0-9_]*$/;
        const FILTER_COLUMN_RE = /^[A-Za-z_][A-Za-z0-9_-]*\.[A-Za-z_][A-Za-z0-9_]*(?:(?:->>|->)'[^'<>`\r\n]*')*$/;

        function isValidPlainLabel(value) {
            return PLAIN_LABEL_RE.test(String(value || '').trim());
        }

        function isValidOutputLabel(value) {
            return isValidPlainLabel(value);
        }

        function outputLabelValidationMessage() {
            return 'Column names may contain only letters, numbers, spaces, underscores, hyphens, periods, and parentheses, up to 128 characters.';
        }

        function reportNameValidationMessage() {
            return 'Report names may contain only letters, numbers, spaces, underscores, hyphens, periods, and parentheses, up to 128 characters.';
        }

        function isValidJoinCondition(condition) {
            return JOIN_CONDITION_RE.test(String(condition || '').trim());
        }

        function joinConditionValidationMessage() {
            return 'Join conditions must be a simple equality between two table-qualified columns, for example users.id = exams.created_by_id.';
        }

        function isValidFilterColumn(column) {
            return FILTER_COLUMN_RE.test(String(column || '').trim());
        }

        function containsScriptLikeInput(value) {
            const text = String(value ?? '');
            if (/[<>`{};]/.test(text)) return true;
            if (Array.from(text).some((character) => {
                const code = character.charCodeAt(0);
                return code <= 8 || code === 11 || code === 12 || (code >= 14 && code <= 31);
            })) return true;
            return /(?:javascript\s*:|<\/?\s*script\b|\bon[a-z]+\s*=|\bdocument\s*\.|\bwindow\s*\.|\beval\s*\(|\bfunction\s*\(|=>)/i.test(text);
        }

        function isValidFilterValue(value) {
            const text = String(value ?? '');
            return text.length <= 2000 && !containsScriptLikeInput(text);
        }

        function isValidFilterCondition(filter) {
            if (!filter || !isValidFilterColumn(filter.column)) return false;
            const operator = String(filter.operator || '').toUpperCase();
            if (!['=', '!=', '<>', '>', '<', '>=', '<=', 'LIKE', 'ILIKE', 'IN', 'IS NULL', 'IS NOT NULL'].includes(operator)) return false;
            if (['IS NULL', 'IS NOT NULL'].includes(operator)) return true;
            const values = operator === 'IN'
                ? (Array.isArray(filter.values) ? filter.values : String(filter.value || '').split(','))
                : [filter.value];
            return values.length > 0 && values.every(value => isValidFilterValue(String(value ?? '').trim()));
        }

        function filterValidationMessage() {
            return 'Filter values cannot contain HTML, JavaScript, event-handler syntax, control characters, or other script-like input.';
        }

        function responseArray(data, key) {
            if (Array.isArray(data)) return data;
            if (key && Array.isArray(data?.[key])) return data[key];
            if (Array.isArray(data?.data)) return data.data;
            if (Array.isArray(data?.results)) return data.results;
            return [];
        }

        function hasFilterForColumn(columnExpression) {
            return filterConditions.some(filter => filter.column === columnExpression);
        }

        function renderFilterButton(table, columnExpression) {
            const isFiltered = hasFilterForColumn(columnExpression);
            const cls = isFiltered ? 'filtered' : 'unfiltered';
            const title = isFiltered ? 'Filter present' : 'Add filter';
            return `<span class='action-btn filter-btn ${cls}' title='${title}' onclick="openFilterDialog('${jsString(table)}', '${jsString(columnExpression)}')">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M3 5h18l-7 8v5l-4 2v-7L3 5z"></path>
                </svg>
            </span>`;
        }


        function setEditorVisible(isVisible) {
            $('#editor-sections').toggle(!!isVisible);
        }

        function organizationChanged() {
            const newOrg = $('#organizations').val() || null;
            if (selectedTables.length || selectedColumnOrder.length || filterConditions.length || joinConditions.length) {
                if (!confirm('Changing organization scope will clear the current builder selections. Continue?')) {
                    
                    return;
                }
                resetBuilderState(false);
            }
            currentOrganizationId = newOrg;
            $('#tables').prop('disabled', !currentOrganizationId);
            refreshAvailableTables();
            refreshSavedReports();
            $('#results-status').text(currentOrganizationId ? 'Add a column to preview the first 15 rows.' : 'Choose an organization before building or running reports.');
        }

        function requireOrganization() {
            currentOrganizationId = currentOrganizationId || ORG_ID;
            if (!currentOrganizationId) {
                alert('Choose an organization first.');
                return false;
            }
            return true;
        }

        function refreshAvailableTables() {
            const select = $('#tables');
            const requestSeq = ++availableTablesRequestSeq;
            const orgId = currentOrganizationId;
            select.empty().append('<option value="">--Choose Table--</option>');
            if (!orgId) {
                select.prop('disabled', true);
                return;
            }
            $.ajax({
                url: API_BASE + '/available_tables',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ organization_id: orgId, tables: selectedTables, table_aliases: tableAliases }),
                success: function(tables) {
                    // Ignore stale overlapping responses. Without this, rapid org/load/reset calls
                    // can append the same table list twice after a later refresh has already cleared it.
                    if (requestSeq !== availableTablesRequestSeq || orgId !== currentOrganizationId) return;
                    const seen = new Set();
                    select.empty().append('<option value="">--Choose Table--</option>');
                    responseArray(tables, 'tables').forEach(table => {
                        if (seen.has(table)) return;
                        seen.add(table);
                        select.append(`<option value="${escapeHtml(table)}">${escapeHtml(table)}</option>`);
                    });
                    select.prop('disabled', false);
                },
                error: function() {
                    if (requestSeq !== availableTablesRequestSeq) return;
                    select.empty().append('<option value="">--Choose Table--</option>');
                    select.prop('disabled', true);
                }
            });
        }

        function resetBuilderState(clearOrg = true) {
            selectedTables = [];
            tableAliases = {};
            selectedColumns = {};
            joinConditions = [];
            filterConditions = [];
            tableColumns = {};
            selectedColumnOrder = [];
            selectedColumnUid = 1;
            currentSavedReportId = null;
            currentSavedReportUserCreated = true;
            currentSavedReportName = '';
            if (clearOrg) {
                currentOrganizationId = ORG_ID;
            }
            $('#selected-tables, #columns-list, #selected-columns, #join-conditions, #filter-conditions').empty();
            $('#saved-report-note').text('');
            setEditorVisible(true);
            $('#results-status').text('Add a column to preview the first 15 rows.');
            $('#results-table thead, #results-table tbody').empty();
            refreshAvailableTables();
        }

        function newReport() {
            resetBuilderState(false);
            $('#saved-reports').val('');
        }

        function refreshSavedReports(selectedId = null) {
            const orgId = currentOrganizationId || ORG_ID || '';
            const select = $('#saved-reports');
            select.empty().append('<option value="">--Choose Saved Report--</option>');
            if (!orgId) {
                return;
            }
            $.ajax({
                url: API_BASE + '/saved_reports?organization_id=' + encodeURIComponent(orgId),
                type: 'GET',
                success: function(reports) {
                    responseArray(reports, 'reports').forEach(report => {
                        const typeLabel = report.user_created ? 'builder' : 'run only';
                        select.append(`<option value="${escapeHtml(report.id)}" data-user-created="${report.user_created}" data-report-name="${escapeHtml(report.report_name)}">${escapeHtml(report.report_name)} (${typeLabel})</option>`);
                    });
                    if (selectedId) select.val(selectedId);
                }
            });
        }

        function renderSelectedTables() {
            const container = $('#selected-tables');
            container.empty();
            selectedTables.forEach(alias => {
                const realTable = tableAliases[alias] || alias;
                const label = alias === realTable ? realTable : `${alias} (${realTable})`;
                container.append(
                    `<div class='item' id='table-${safeId(alias)}'>
                        <span class='item-main'>${escapeHtml(label)}</span>
                        <span class='action-btn remove-btn' onclick="removeTable('${jsString(alias)}')">x</span>
                    </div>`
                );
            });
        }

        function loadSelectedReport() {
            if (!requireOrganization()) return;
            const reportId = $('#saved-reports').val();
            if (!reportId) return;
            $.ajax({
                url: API_BASE + `/saved_reports/${reportId}?organization_id=${encodeURIComponent(currentOrganizationId)}`,
                type: 'GET',
                success: function(report) {
                    currentSavedReportId = report.id;
                    currentSavedReportUserCreated = !!report.user_created;
                    currentSavedReportName = report.report_name || '';
                    $('#saved-report-note').text(report.user_created ? 'Loaded builder report.' : 'Loaded run-only report.');
                    if (report.user_created && report.payload) {
                        applyBuilderPayload(report.payload);
                        setEditorVisible(true);
                        schedulePreview();
                    } else {
                        resetBuilderState(false);
                        currentSavedReportId = report.id;
                        currentSavedReportUserCreated = false;
                        currentSavedReportName = report.report_name || '';
                        setEditorVisible(false);
                        $('#saved-report-note').text('Run-only report loaded. The editor is hidden for this report.');
                        runSelectedSavedReport();
                    }
                },
                error: function(xhr) {
                    alert(safeApiErrorMessage(xhr, 'Unable to load saved report.'));
                }
            });
        }

        function applyBuilderPayload(payload) {
            selectedTables = Array.isArray(payload.tables) ? [...payload.tables] : [];
            tableAliases = payload.table_aliases || {};
            joinConditions = (Array.isArray(payload.joins) ? payload.joins : []).filter(join =>
                join && ['INNER', 'LEFT', 'RIGHT', 'FULL'].includes(String(join.joinType || 'INNER').toUpperCase()) && isValidJoinCondition(join.condition)
            );
            filterConditions = (Array.isArray(payload.filters) ? payload.filters : []).filter(isValidFilterCondition);

            const ordered = Array.isArray(payload.ordered_columns) && payload.ordered_columns.length
                ? payload.ordered_columns
                : Object.entries(payload.columns || {}).flatMap(([table, cols]) => (cols || []).map(column => ({
                    table,
                    column,
                    expression: `${table}.${column}`,
                    display: `${table}.${column}`
                })));

            selectedColumnOrder = dedupeSelectedColumnOrder(ordered.map(item => {
                const storedLabel = String(item.label || '').trim();
                return {
                    ...item,
                    expression: item.expression || `${item.table}.${item.column}`,
                    display: item.display || item.expression || `${item.table}.${item.column}`,
                    label: storedLabel && isValidOutputLabel(storedLabel) ? storedLabel : null,
                    uid: item.uid || `col_${selectedColumnUid++}`
                };
            }));
            resetSelectedColumnUidCounter();
            rebuildSelectedColumnsFromOrder();

            tableColumns = {};
            renderSelectedTables();
            renderJoins();
            renderFilters();
            renderSelectedColumns();
            selectedTables.forEach(alias => fetchColumns(alias));
        }

        function runSelectedSavedReport() {
            if (!requireOrganization()) return;
            const reportId = currentSavedReportId || $('#saved-reports').val();
            if (!reportId) {
                alert('Choose a saved report first.');
                return;
            }
            $('#results-status').text('Running saved report...');
            $.ajax({
                url: API_BASE + `/saved_reports/${reportId}/run`,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ limit: document.getElementById('limit').value || null, organization_id: currentOrganizationId }),
                success: function(data) {
                    $('#results-status').text('Saved report complete.');
                    renderResults(data);
                },
                error: function(xhr) {
                    alert(safeApiErrorMessage(xhr, 'Error running saved report.'));
                    $('#results-status').text('Saved report failed.');
                }
            });
        }

        function deleteSelectedSavedReport() {
            if (!requireOrganization()) return;
            const reportId = currentSavedReportId || $('#saved-reports').val();
            if (!reportId) {
                alert('Load or choose a saved report first.');
                return;
            }
            const selectedOption = $('#saved-reports').find('option:selected');
            const isUserCreated = String(selectedOption.data('user-created')) !== 'false';
            if (!currentSavedReportUserCreated || !isUserCreated) {
                alert('Admin-created reports cannot be deleted from Ad-Hoc Reporting.');
                return;
            }
            const reportName = selectedOption.text() || 'this saved report';
            if (!confirm(`Delete ${reportName}? This cannot be undone.`)) return;
            $.ajax({
                url: API_BASE + `/saved_reports/${reportId}`,
                type: 'DELETE',
                contentType: 'application/json',
                data: JSON.stringify({ organization_id: currentOrganizationId }),
                success: function() {
                    currentSavedReportId = null;
                    $('#saved-report-note').text('Saved report deleted.');
                    $('#saved-reports').val('');
                    refreshSavedReports();
                    newReport();
                },
                error: function(xhr) {
                    alert(safeApiErrorMessage(xhr, 'Unable to delete saved report.'));
                }
            });
        }

        function openSaveReportDialog() {
            if (selectedColumnOrder.length === 0) {
                alert('Add at least one selected column before saving.');
                return;
            }
            $('#save-report-name').val(currentSavedReportId && currentSavedReportUserCreated ? currentSavedReportName : '');
            $('#save-report-modal').show();
        }

        function closeSaveReportDialog() {
            $('#save-report-modal').hide();
        }

        function saveReport() {
            if (!requireOrganization()) return;
            const name = $('#save-report-name').val().trim();
            if (!name) {
                alert('Enter a report name.');
                return;
            }
            if (!isValidPlainLabel(name)) {
                alert(reportNameValidationMessage());
                return;
            }
            const isUpdate = currentSavedReportId && currentSavedReportUserCreated;
            $.ajax({
                url: isUpdate ? API_BASE + `/saved_reports/${currentSavedReportId}` : API_BASE + '/save_report',
                type: isUpdate ? 'PUT' : 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ report_name: name, payload: buildQueryPayload() }),
                success: function(report) {
                    closeSaveReportDialog();
                    currentSavedReportId = report.id;
                    currentSavedReportUserCreated = true;
                    currentSavedReportName = report.report_name || name;
                    $('#saved-report-note').text(`${isUpdate ? 'Updated' : 'Saved'}: ${report.report_name}`);
                    refreshSavedReports(report.id);
                },
                error: function(xhr) {
                    alert(safeApiErrorMessage(xhr, 'Unable to save report.'));
                }
            });
        }

        function makeTableAlias(table) {
            if (!selectedTables.includes(table)) return table;
            let index = 1;
            while (selectedTables.includes(`${table}-${index}`)) index++;
            return `${table}-${index}`;
        }

        function addTable() {
            if (!requireOrganization()) return;
            let table = $('#tables').val();
            if (table) {
                const alias = makeTableAlias(table);
                selectedTables.push(alias);
                tableAliases[alias] = table;
                selectedColumns[alias] = [];
                const label = alias === table ? table : `${alias} (${table})`;
                $('#selected-tables').append(
                    `<div class='item' id='table-${safeId(alias)}'>
                        <span class='item-main'>${label}</span>
                        <span class='action-btn remove-btn' onclick="removeTable('${alias}')">x</span>
                    </div>`
                );
                fetchColumns(alias);
                refreshAutoJoins(alias);
                refreshAvailableTables();
                schedulePreview();
            }
        }

        function refreshAutoJoins(newAlias = null) {
            if (selectedTables.length < 2) return;
            $.ajax({
                url: API_BASE + '/get_joins',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ tables: selectedTables, table_aliases: tableAliases }),
                success: function(data) {
                    responseArray(data, 'joins').forEach(join => {
                        const involvesNewAlias = !newAlias || join.condition.includes(`${newAlias}.`);
                        if (involvesNewAlias && !joinConditions.some(j => j.condition === join.condition)) {
                            joinConditions.push(join);
                        }
                    });
                    renderJoins();
                    schedulePreview();
                }
            });
        }

        function renderJoins() {
            let container = $('#join-conditions');
            container.empty();
            joinConditions.forEach((join, index) => {
                container.append(`
                    <div class='item' id='join-${index}'>
                        <select class='join-type' onchange="updateJoinType(${index}, this.value)">
                            ${['INNER','LEFT','RIGHT','FULL'].map(t => `<option value='${t}' ${join.joinType === t ? 'selected' : ''}>${t}</option>`).join('')}
                        </select>
                        <input class='join-condition-input' value="${escapeHtml(join.condition)}" onchange="updateJoinCondition(${index}, this.value)">
                        <span class='action-btn' onclick="editJoinCondition(${index})">edit</span>
                        <span class='action-btn remove-btn' onclick="removeJoin(${index})">x</span>
                    </div>
                `);
            });
        }

        function updateJoinType(index, joinType) {
            joinConditions[index].joinType = joinType;
            schedulePreview();
        }

        function updateJoinCondition(index, condition) {
            condition = String(condition || '').trim();
            if (!isValidJoinCondition(condition)) {
                alert(joinConditionValidationMessage());
                renderJoins();
                return;
            }
            joinConditions[index].condition = condition;
            schedulePreview();
        }

        function editJoinCondition(index) {
            openJoinDialog(index);
        }

        function openJoinDialog(index = null) {
            currentJoinIndex = index;
            const join = index === null ? { joinType: 'INNER', condition: '' } : joinConditions[index];
            $('#join-title').text(index === null ? 'Add Join Condition' : 'Edit Join Condition');
            $('#join-type-dialog').val(join.joinType || 'INNER');
            $('#join-condition-dialog').val(join.condition || '');
            $('#join-suggestions').empty();
            $('#join-modal').show();
            loadSuggestedJoins();
        }

        function closeJoinDialog() {
            $('#join-modal').hide();
            currentJoinIndex = null;
        }

        function loadSuggestedJoins() {
            const suggestions = $('#join-suggestions');
            suggestions.empty();
            if (selectedTables.length < 2) {
                suggestions.append('<option disabled>Select at least two tables first.</option>');
                return;
            }
            $.ajax({
                url: API_BASE + '/get_joins',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ tables: selectedTables, table_aliases: tableAliases }),
                success: function(data) {
                    suggestions.empty();
                    const existing = new Set(joinConditions.map((j, idx) => idx === currentJoinIndex ? null : j.condition));
                    responseArray(data, 'joins').filter(join => !existing.has(join.condition)).forEach(join => {
                        suggestions.append(`<option value="${escapeHtml(join.condition)}" data-join-type="${join.joinType || 'INNER'}">${escapeHtml(join.condition)}</option>`);
                    });
                    if (!suggestions.children().length) {
                        suggestions.append('<option disabled>No unused suggestions found. Type a custom condition below.</option>');
                    }
                },
                error: function() {
                    suggestions.empty().append('<option disabled>Unable to load suggested joins.</option>');
                }
            });
        }

        $('#join-suggestions').on('change', function() {
            const selected = $(this).find('option:selected');
            const condition = selected.val();
            if (condition) {
                $('#join-condition-dialog').val(condition);
                $('#join-type-dialog').val(selected.data('join-type') || 'INNER');
            }
        });

        function saveJoinFromDialog() {
            const condition = $('#join-condition-dialog').val().trim();
            const joinType = $('#join-type-dialog').val();
            if (!condition) {
                alert('Enter or select a join condition.');
                return;
            }
            if (!isValidJoinCondition(condition)) {
                alert(joinConditionValidationMessage());
                return;
            }
            const join = { joinType, condition };
            if (currentJoinIndex === null) {
                joinConditions.push(join);
            } else {
                joinConditions[currentJoinIndex] = { ...joinConditions[currentJoinIndex], ...join };
            }
            renderJoins();
            closeJoinDialog();
            schedulePreview();
        }

        function removeJoin(index) {
            joinConditions.splice(index, 1);
            renderJoins();
            schedulePreview();
        }

        function removeTable(table) {
            // Removing a table also removes any visible joins, selected columns, and filters
            // that reference that table alias. The hidden organization scope is enforced
            // server-side and is not represented as a removable join here.
            joinConditions = joinConditions.filter(join => !conditionReferencesAlias(join.condition || '', table));
            filterConditions = filterConditions.filter(filter => filter.table !== table && !conditionReferencesAlias(filter.expression || '', table));
            selectedTables = selectedTables.filter(t => t !== table);
            delete selectedColumns[table];
            selectedColumnOrder = selectedColumnOrder.filter(item => item.table !== table);
            delete tableColumns[table];
            delete tableAliases[table];
            $(`#table-${safeId(table)}`).remove();
            renderJoins();
            renderFilters();
            renderAvailableColumns();
            renderSelectedColumns();
            refreshAvailableTables();
            schedulePreview();
        }

        function conditionReferencesAlias(condition, alias) {
            const escaped = alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            return new RegExp(`(^|[^A-Za-z0-9_-])${escaped}\\.`, 'i').test(condition || '');
        }

        function fetchColumns(alias) {
            const realTable = tableAliases[alias] || alias;
            $.ajax({
                url: API_BASE + '/get_columns',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ table: realTable }),
                success: function(data) {
                    const columns = responseArray(data, 'columns');
                    tableColumns[alias] = columns.map(col => ({
                        ...col,
                        table: alias,
                        realTable: realTable,
                        fullName: `${alias}.${col.name}`
                    }));
                    renderAvailableColumns();
                    renderSelectedColumns();
                },
                error: function(xhr) {
                    tableColumns[alias] = [];
                    renderAvailableColumns();
                    $('#columns-list').append(`<div class='text-danger'>${escapeHtml(safeApiErrorMessage(xhr, `Unable to load columns for ${alias}.`))}</div>`);
                }
            });
        }

        function getColumnMeta(table, column) {
            return (tableColumns[table] || []).find(col => col.name === column) || {};
        }

        function isJsonColumn(table, column) {
            const meta = getColumnMeta(table, column);
            return ['json', 'jsonb'].includes(String(meta.dataType || '').toLowerCase());
        }

        function ensureColumnUid(item) {
            if (!item.uid) item.uid = `col_${selectedColumnUid++}`;
            return item.uid;
        }

        function columnSignature(item) {
            return [
                item.table || '',
                item.column || '',
                item.expression || `${item.table}.${item.column}`,
                JSON.stringify(item.jsonPath || item.path || null),
                item.label || ''
            ].join('|');
        }

        function dedupeSelectedColumnOrder(items) {
            const seen = new Set();
            return (items || []).filter(item => {
                const signature = columnSignature(item);
                if (seen.has(signature)) return false;
                seen.add(signature);
                return true;
            });
        }

        function rebuildSelectedColumnsFromOrder() {
            const rebuilt = {};
            selectedTables.forEach(alias => { rebuilt[alias] = []; });
            selectedColumnOrder.forEach(item => {
                if (!item.table || !item.column) return;
                if (!rebuilt[item.table]) rebuilt[item.table] = [];
                if (!rebuilt[item.table].includes(item.column)) rebuilt[item.table].push(item.column);
            });
            selectedColumns = rebuilt;
        }

        function resetSelectedColumnUidCounter() {
            let maxUid = 0;
            selectedColumnOrder.forEach(item => {
                const match = String(item.uid || '').match(/^col_(\d+)$/);
                if (match) maxUid = Math.max(maxUid, parseInt(match[1], 10));
            });
            selectedColumnUid = maxUid + 1;
        }

        function applyLikeWildcardsToValue(value) {
            value = String(value ?? '').trim();
            if (!value) return value;
            const values = value.split(',').map(part => {
                let item = part.trim();
                if (!item) return item;
                if (!item.startsWith('%')) item = '%' + item;
                if (!item.endsWith('%')) item = item + '%';
                return item;
            });
            return values.join(', ');
        }

        function normalizeLikeFilterValue() {
            const operator = String($('#filter-operator').val() || '').toUpperCase();
            if (!['LIKE', 'ILIKE'].includes(operator)) return;
            const current = $('#filter-value').val();
            const wrapped = applyLikeWildcardsToValue(current);
            if (wrapped !== current) $('#filter-value').val(wrapped);
        }

        function syncSelectedColumnOrderFromDom() {
            const ordered = [];
            $('.selected-column-item').each(function() {
                const uid = $(this).attr('data-uid');
                const item = selectedColumnOrder.find(col => col.uid === uid);
                if (item) ordered.push(item);
            });
            if (ordered.length === selectedColumnOrder.length) selectedColumnOrder = ordered;
        }

        function itemSystemName(item) {
            return item.display || item.expression || `${item.table}.${item.column}`;
        }

        function isSelectedBaseColumn(table, column) {
            return selectedColumnOrder.some(item => item.table === table && item.column === column && !item.jsonPath);
        }

        function renderAvailableColumns() {
            let columnList = $('#columns-list');
            columnList.empty();
            selectedTables.forEach(table => {
                (tableColumns[table] || []).forEach(col => {
                    if (isSelectedBaseColumn(table, col.name) && !['json', 'jsonb'].includes(String(col.dataType || '').toLowerCase())) return;
                    columnList.append(`<div class='item' id='col-${safeId(col.fullName)}'>
                        <span class='item-main'>${col.fullName} <small>(${col.dataType})</small></span>
                        <span class='action-btn' onclick="selectColumn('${table}', '${col.name}')">+</span>
                    </div>`);
                });
            });
        }

        function renderJsonButton(item, index) {
            if (!isJsonColumn(item.table, item.column)) return '';
            return `<span class='action-btn' title='Add JSONB element' onclick="openJsonbDialog(${index})">{ }</span>`;
        }

        function renderSelectedColumns() {
            let selected = $('#selected-columns');
            selected.empty();
            selectedColumnOrder.forEach((item, index) => {
                const uid = ensureColumnUid(item);
                const table = item.table;
                const column = item.column;
                const systemName = itemSystemName(item);
                const label = item.label ? `${systemName} (${item.label})` : systemName;
                selected.append(
                    `<div class='item selected-column-item' draggable='true' data-index='${index}' data-uid='${escapeHtml(uid)}' id='selected-${safeId(uid)}'>
                        <span class='item-main'><span class='drag-handle' title='Drag to reorder'>☰</span>${escapeHtml(label)}</span>
                        <span>
                            ${renderFilterButton(table, item.expression || `${table}.${column}`)}
                            ${renderJsonButton(item, index)}
                            <span class='action-btn' title='Rename output column' onclick="openAliasDialog(${index})">rename</span>
                            <span class='action-btn remove-btn' onclick="removeColumnByIndex(${index})">x</span>
                        </span>
                    </div>`
                );
            });
            attachColumnDragHandlers();
        }

        function attachColumnDragHandlers() {
            $('.selected-column-item').off('dragstart dragover drop dragend');
            $('.selected-column-item').on('dragstart', function(e) {
                $(this).addClass('dragging');
                e.originalEvent.dataTransfer.setData('text/plain', $(this).attr('data-uid'));
            });
            $('.selected-column-item').on('dragover', function(e) {
                e.preventDefault();
            });
            $('.selected-column-item').on('drop', function(e) {
                e.preventDefault();
                const fromUid = e.originalEvent.dataTransfer.getData('text/plain');
                const toUid = $(this).attr('data-uid');
                const from = selectedColumnOrder.findIndex(item => item.uid === fromUid);
                const to = selectedColumnOrder.findIndex(item => item.uid === toUid);
                if (from >= 0 && to >= 0 && from !== to) {
                    const [moved] = selectedColumnOrder.splice(from, 1);
                    selectedColumnOrder.splice(to, 0, moved);
                    renderSelectedColumns();
                    schedulePreview();
                }
            });
            $('.selected-column-item').on('dragend', function() {
                $(this).removeClass('dragging');
            });
        }

        function selectColumn(table, column) {
            if (isSelectedBaseColumn(table, column)) {
                renderAvailableColumns();
                renderSelectedColumns();
                return;
            }
            if (!selectedColumns[table]) selectedColumns[table] = [];
            if (!selectedColumns[table].includes(column)) selectedColumns[table].push(column);
            selectedColumnOrder.push({ uid: `col_${selectedColumnUid++}`, table, column, expression: `${table}.${column}`, display: `${table}.${column}` });
            selectedColumnOrder = dedupeSelectedColumnOrder(selectedColumnOrder);
            rebuildSelectedColumnsFromOrder();
            renderAvailableColumns();
            renderSelectedColumns();
            schedulePreview();
        }

        function removeColumnByIndex(index) {
            const item = selectedColumnOrder[index];
            if (!item) return;
            selectedColumnOrder.splice(index, 1);
            const stillSelected = selectedColumnOrder.some(other => other.table === item.table && other.column === item.column);
            if (!stillSelected && selectedColumns[item.table]) {
                selectedColumns[item.table] = selectedColumns[item.table].filter(col => col !== item.column);
            }
            renderAvailableColumns();
            renderSelectedColumns();
            schedulePreview();
        }

        function addJoinCondition() {
            openJoinDialog(null);
        }

        function openFilterDialog(table = null, column = '') {
            currentFilterTable = table || (column.includes('.') ? column.split('.')[0] : null);
            $('#filter-column').val(column);
            $('#filter-operator').val('=');
            $('#filter-value').val('');
            $('#filter-samples').empty();
            $('#filter-modal').show();
        }

        function closeFilterDialog() {
            $('#filter-modal').hide();
        }

        function loadSampleValues() {
            if (!requireOrganization()) return;
            let column = $('#filter-column').val().trim();
            let table = currentFilterTable || (column.includes('.') ? column.split('.')[0] : null);
            if (!table || !column) {
                alert('Enter a table-qualified column expression first.');
                return;
            }
            $.ajax({
                url: API_BASE + '/sample_filter_values',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ table: table, column: column, tables: selectedTables, table_aliases: tableAliases, joins: joinConditions, filters: filterConditions, limit: 50, organization_id: currentOrganizationId }),
                success: function(values) {
                    const samples = document.getElementById('filter-samples');
                    samples.textContent = '';
                    responseArray(values, 'values').forEach(value => {
                        const option = document.createElement('option');
                        option.value = String(value ?? '');
                        option.textContent = String(value ?? '');
                        samples.appendChild(option);
                    });
                },
                error: function(xhr) {
                    alert(safeApiErrorMessage(xhr, 'Unable to load sample values.'));
                }
            });
        }

        $('#filter-samples').on('change', function() {
            let values = $(this).val() || [];
            let value = values.join(', ');
            const operator = String($('#filter-operator').val() || '').toUpperCase();
            if (['LIKE', 'ILIKE'].includes(operator)) value = applyLikeWildcardsToValue(value);
            $('#filter-value').val(value);
        });

        $('#filter-operator').on('change', normalizeLikeFilterValue);
        $('#filter-value').on('change', normalizeLikeFilterValue);

        function saveFilterFromDialog() {
            let column = $('#filter-column').val().trim();
            let operator = $('#filter-operator').val();
            let value = $('#filter-value').val().trim();
            if (!value) {
                const selectedSamples = $('#filter-samples').val() || [];
                if (Array.isArray(selectedSamples) && selectedSamples.length) {
                    value = selectedSamples.join(', ');
                    if (['LIKE', 'ILIKE'].includes(String(operator || '').toUpperCase())) {
                        value = applyLikeWildcardsToValue(value);
                    }
                    $('#filter-value').val(value);
                }
            }
            if (!column || !operator) return;
            if (!isValidFilterColumn(column)) {
                alert('Filter columns must be a table-qualified column or a valid JSONB path expression.');
                return;
            }
            if (!['IS NULL', 'IS NOT NULL'].includes(operator) && value === '') {
                alert('Enter or select a filter value.');
                return;
            }
            if (!['IS NULL', 'IS NOT NULL'].includes(operator) && !isValidFilterValue(value)) {
                alert(filterValidationMessage());
                return;
            }
            let filter = { column, operator, value };
            if (operator === 'IN') {
                filter.values = value.split(',').map(v => v.trim()).filter(Boolean);
            }
            filterConditions.push(filter);
            renderFilters();
            closeFilterDialog();
            schedulePreview();
        }

        function renderFilters() {
            const container = document.getElementById('filter-conditions');
            container.textContent = '';
            filterConditions = filterConditions.filter(isValidFilterCondition);
            filterConditions.forEach((filter, index) => {
                const displayValue = filter.operator === 'IN' ? (filter.values || []).join(', ') : (filter.value || '');
                const row = document.createElement('div');
                row.className = 'item';
                row.id = `filter-${index}`;

                const text = document.createElement('span');
                text.className = 'item-main';
                text.textContent = `${filter.column || ''} ${filter.operator || ''} ${displayValue}`;

                const remove = document.createElement('span');
                remove.className = 'action-btn remove-btn';
                remove.textContent = 'x';
                remove.addEventListener('click', () => removeFilter(index));

                row.appendChild(text);
                row.appendChild(remove);
                container.appendChild(row);
            });
            renderSelectedColumns();
        }

        function removeFilter(index) {
            filterConditions.splice(index, 1);
            renderFilters();
            schedulePreview();
        }

        function openJsonbDialog(index) {
            currentJsonbItem = selectedColumnOrder[index];
            if (!currentJsonbItem) return;
            $('#jsonb-source').text(`Source: ${currentJsonbItem.table}.${currentJsonbItem.column}`);
            $('#jsonb-custom-path').val('');
            $('#jsonb-paths').empty();
            $('#jsonb-modal').show();
            loadJsonbPaths();
        }

        function closeJsonbDialog() {
            $('#jsonb-modal').hide();
            currentJsonbItem = null;
        }

        function loadJsonbPaths() {
            if (!requireOrganization()) return;
            if (!currentJsonbItem) return;
            const paths = $('#jsonb-paths');
            paths.empty().append('<option disabled>Loading...</option>');
            $.ajax({
                url: API_BASE + '/jsonb_keys',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ table: currentJsonbItem.table, column: currentJsonbItem.column, tables: selectedTables, table_aliases: tableAliases, joins: joinConditions, filters: filterConditions, organization_id: currentOrganizationId }),
                success: function(data) {
                    paths.empty();
                    data.forEach(item => paths.append(`<option value="${escapeHtml(JSON.stringify(item))}">${escapeHtml(item.label)}</option>`));
                    if (!paths.children().length) paths.append('<option disabled>No JSON paths found. Type one below.</option>');
                },
                error: function() {
                    paths.empty().append('<option disabled>Unable to load JSON paths.</option>');
                }
            });
        }

        function saveJsonbElement() {
            if (!currentJsonbItem) return;
            let pathInfo = null;
            const selected = $('#jsonb-paths').val();
            if (selected) pathInfo = JSON.parse(selected);
            const custom = $('#jsonb-custom-path').val().trim();
            if (custom) {
                const path = custom.split('.').map(p => p.trim()).filter(Boolean);
                if (!path.length) return;
                let expr = `${currentJsonbItem.table}.${currentJsonbItem.column}`;
                path.forEach((key, idx) => {
                    expr += `${idx === path.length - 1 ? '->>' : '->'}'${key}'`;
                });
                pathInfo = { path, label: path.join('.'), expression: expr, display: `${currentJsonbItem.table}.${currentJsonbItem.column},${path.join('.')}` };
            }
            if (!pathInfo) {
                alert('Select or type a JSON path.');
                return;
            }
            selectedColumnOrder.push({
                uid: `col_${selectedColumnUid++}`,
                table: currentJsonbItem.table,
                column: currentJsonbItem.column,
                expression: pathInfo.expression,
                display: pathInfo.display,
                jsonPath: pathInfo.path
            });
            renderSelectedColumns();
            closeJsonbDialog();
            schedulePreview();
        }

        function openAliasDialog(index) {
            currentAliasIndex = index;
            const item = selectedColumnOrder[index];
            $('#alias-source').text(`System name: ${itemSystemName(item)}`);
            $('#alias-value').val(item.label || '');
            $('#alias-modal').show();
        }

        function closeAliasDialog() {
            $('#alias-modal').hide();
            currentAliasIndex = null;
        }

        function saveColumnAlias() {
            if (currentAliasIndex === null) return;
            const value = $('#alias-value').val().trim();
            if (value && !isValidOutputLabel(value)) {
                alert(outputLabelValidationMessage());
                return;
            }
            selectedColumnOrder[currentAliasIndex].label = value || null;
            renderSelectedColumns();
            closeAliasDialog();
            schedulePreview();
        }

        function buildQueryPayload(limitOverride = null) {
            syncSelectedColumnOrderFromDom();
            selectedColumnOrder = dedupeSelectedColumnOrder(selectedColumnOrder);
            rebuildSelectedColumnsFromOrder();
            const orderedColumns = selectedColumnOrder.map(item => ({
                uid: item.uid,
                table: item.table,
                column: item.column,
                expression: item.expression || `${item.table}.${item.column}`,
                display: item.display || item.expression || `${item.table}.${item.column}`,
                label: item.label || null,
                jsonPath: item.jsonPath || item.path || null
            }));
            const payload = {
                tables: selectedTables,
                table_aliases: tableAliases,
                columns: selectedColumns,
                ordered_columns: orderedColumns,
                joins: joinConditions,
                filters: filterConditions,
                organization_id: currentOrganizationId
            };
            if (limitOverride !== null) {
                payload.limit = limitOverride;
            } else {
                const selectedLimit = document.getElementById('limit').value;
                if (selectedLimit) payload.limit = parseInt(selectedLimit);
            }
            return payload;
        }

        function renderResults(data) {
            let thead = $('#results-table thead');
            let tbody = $('#results-table tbody');
            thead.empty();
            tbody.empty();
            if (data.length > 0) {
                let headers = Object.keys(data[0]);
                // Result headers and values can contain user-controlled/stored data.
                // Build the result grid with DOM nodes and textContent instead of
                // interpolating values into HTML. This prevents stored XSS in renamed
                // output columns and also protects cells containing HTML-like data.
                const headerRow = document.createElement('tr');
                headers.forEach(header => {
                    const th = document.createElement('th');
                    th.textContent = String(header ?? '');
                    headerRow.appendChild(th);
                });
                thead.append(headerRow);
                data.forEach(row => {
                    const tr = document.createElement('tr');
                    headers.forEach(header => {
                        const td = document.createElement('td');
                        td.textContent = String(row[header] ?? '');
                        tr.appendChild(td);
                    });
                    tbody.append(tr);
                });
            } else {
                tbody.append('<tr><td colspan="100%">No data found</td></tr>');
            }
        }

        function schedulePreview() {
            clearTimeout(previewTimer);
            previewTimer = setTimeout(previewQuery, 350);
        }

        function previewQuery() {
            if (!currentOrganizationId) {
                $('#results-status').text('Choose an organization before previewing.');
                return;
            }
            if (selectedColumnOrder.length === 0) {
                $('#results-status').text('Add a column to preview the first 15 rows.');
                $('#results-table thead, #results-table tbody').empty();
                return;
            }
            $('#results-status').text('Previewing first 15 rows...');
            $.ajax({
                url: API_BASE + '/run_query',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(buildQueryPayload(15)),
                success: function(data) {
                    $('#results-status').text('Preview: first 15 rows. Click Run Query for the selected result limit.');
                    renderResults(data);
                },
                error: function(xhr) {
                    let message = safeApiErrorMessage(xhr, 'Preview unavailable.');
                    if (message === 'Selected tables do not include an organization-scoped table or join path') {
                        message = 'Add appropriate tables.';
                    }
                    $('#results-status').text('Preview unavailable: ' + message);
                }
            });
        }

        function runQuery() {
            if (!requireOrganization()) return;
            $('#results-status').text('Running query...');
            $.ajax({
                url: API_BASE + '/run_query',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(buildQueryPayload()),
                success: function(data) {
                    $('#results-status').text('Query complete.');
                    renderResults(data);
                },
                error: function(xhr) {
                    alert(safeApiErrorMessage(xhr, 'Error running query.'));
                    $('#results-status').text('Query failed.');
                }
            });
        }

        function exportFile(format) {
            const endpoint = format === 'xlsx' ? '/export_xlsx' : '/export_csv';
            const filename = format === 'xlsx' ? 'exported_report.xlsx' : 'exported_report.csv';
            $.ajax({
                url: API_BASE + endpoint,
                type: 'GET',
                xhrFields: { responseType: 'blob' },
                success: function(blob) {
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                },
                error: function(xhr) {
                    alert(safeApiErrorMessage(xhr, 'Error downloading file.'));
                }
            });
        }

        function exportCSV() {
            $.ajax({
                url: API_BASE + '/export_csv',
                type: 'GET',
                xhrFields: { responseType: 'blob' },
                success: function(blob) {
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'exported_report.csv';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                },
                error: function(xhr) {
                    alert(safeApiErrorMessage(xhr, 'Error downloading file.'));
                }
            });
        }

  Object.assign(window, {
    organizationChanged, loadSelectedReport, runSelectedSavedReport, deleteSelectedSavedReport, newReport,
    addTable, addJoinCondition, openFilterDialog, runQuery, exportCSV, exportFile,
    saveReport, closeSaveReportDialog, openSaveReportDialog, closeFilterDialog,
    loadSampleValues, saveFilterFromDialog, closeJoinDialog, loadSuggestedJoins,
    saveJoinFromDialog, closeJsonbDialog, loadJsonbPaths, saveJsonbElement,
    closeAliasDialog, saveColumnAlias, removeTable, editJoinCondition, removeJoin,
    updateJoinType, updateJoinCondition, selectColumn, removeColumnByIndex,
    openJsonbDialog, openAliasDialog, removeFilter
  });

        $(function() {
            currentOrganizationId = ORG_ID;
            $('#tables').prop('disabled', false);
            refreshSavedReports();
            refreshAvailableTables();
            $('#results-status').text('Add a column to preview the first 15 rows.');
        });
    
}
